/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const CREATE_STUB_INVOICE_LOADING = "CREATE_STUB_INVOICE_LOADING";
export const CREATE_STUB_INVOICE_REBATE_PROGRAM_DATA =
  "CREATE_STUB_INVOICE_REBATE_PROGRAM_DATA";
export const CREATE_STUB_INVOICE_FILTER = "CREATE_STUB_INVOICE_FILTER";
export const CREATE_STUB_INVOICE_USERDEFAULT =
  "CREATE_STUB_INVOICE_USERDEFAULT";
export const CREATE_STUB_INVOICE_RESET_STORE =
  "CREATE_STUB_INVOICE_RESET_STORE";
export const SET_ERROR_MESSAGES = "SET_ERROR_MESSAGES";
